// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b52bcb2ac90e387e01da","293":"7d8432f1c90b676baf21","518":"eddd56c7604bb081318c","779":"9687345fa443acb71652"}[chunkId] + ".js";
};